import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule as JumpstartComponentsModule_v3 } from "@wk/components-v3-angular17";
import { FormsModule } from "@angular/forms";
import { TooltipsModule } from "@progress/kendo-angular-tooltip";
import { DropDownListModule, MultiSelectModule } from "@progress/kendo-angular-dropdowns";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { FollowUpInfoComponent } from "@app/card-modal-component/follow-up-info-component/follow-up-info.component";
import { CardsService } from "@services/index";
import {
    WkTranslatePipe,
    NestedValuePipe,
    TestDataPipe,
    CloseOnAncestorScrollDirective,
    AddEditComponent,
    DateAgoPipe,
    TruncatePipe,
    AppLoaderComponent,
    KendoDropDownListWrapper,
    KendoMultiselectWrapper,
    SettingsBreadcrumbComponent,
    CardTitlePipe,
} from "@shared/index";
import { IconsModule } from "@icons/module";

@NgModule({
    declarations: [
        NestedValuePipe,
        TestDataPipe,
        SettingsBreadcrumbComponent,
        AddEditComponent,
        TruncatePipe,
        CardTitlePipe,
        KendoDropDownListWrapper,
        KendoMultiselectWrapper,
        FollowUpInfoComponent,
        DateAgoPipe,
    ],
    imports: [
        IconsModule,
        CloseOnAncestorScrollDirective,
        CommonModule,
        TranslateModule,
        JumpstartComponentsModule_v3,
        FormsModule,
        TooltipsModule,
        WkTranslatePipe,
        DropDownListModule,
        MultiSelectModule,
        ButtonsModule,
        AppLoaderComponent,
    ],
    exports: [
        IconsModule,
        CloseOnAncestorScrollDirective,
        WkTranslatePipe,
        AppLoaderComponent,
        NestedValuePipe,
        TestDataPipe,
        SettingsBreadcrumbComponent,
        AddEditComponent,
        TruncatePipe,
        CardTitlePipe,
        KendoDropDownListWrapper,
        KendoMultiselectWrapper,
        FollowUpInfoComponent,
        DateAgoPipe,
        DropDownListModule,
        MultiSelectModule,
        ButtonsModule,
    ],
    providers: [CardsService],
})
export class SharedModule {}
